import { useEffect } from "react";

import { IS_PREVIEW } from "../lib/pro-mode";
import { useProfileStore } from "../stores/profile";
import { useRoleStore } from "../stores/role";

/**
 * Bridge the shared profile store → the role store (SILL-346 item 4): once the
 * authenticated agent's real `profile.role` resolves, it drives the app's active
 * viewing role. Lives in the authed shell (ProLayout), which already consumes
 * the profile store via the gate's warm fetch.
 *
 * Guarded by `!IS_PREVIEW` so it never clobbers a preview user's manual Agent/LO
 * toggle — in preview the fixture seeds the role and the (preview-only) toggle
 * drives it. In prod the toggle is hidden, so the role settles to the real type
 * and stays there.
 */
export function useRoleHydration(): void {
  const role = useProfileStore((s) => s.data?.role);

  useEffect(() => {
    if (IS_PREVIEW) return;
    if (role) useRoleStore.getState().setRole(role);
  }, [role]);
}
